/* Product detail page interactions: countdown, interactive seat map, live
   price, add-on lines. Vanilla and defensive — each block no-ops if its markup
   is absent, so this file is safe to load on any template. */
(function () {
  "use strict";

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  /* -------------------------------------------------------------------------
     Countdown to show time.
  ------------------------------------------------------------------------- */
  var cd = $("[data-countdown]");
  if (cd) {
    var target = new Date(cd.getAttribute("data-target")).getTime();
    var fields = {
      days: $('[data-cd="days"]', cd),
      hours: $('[data-cd="hours"]', cd),
      minutes: $('[data-cd="minutes"]', cd),
      seconds: $('[data-cd="seconds"]', cd),
    };
    var pad = function (n) { return n < 10 ? "0" + n : String(n); };

    var tick = function () {
      if (isNaN(target)) { cd.hidden = true; return; }
      var diff = target - Date.now();
      if (diff <= 0) {
        Object.keys(fields).forEach(function (k) { if (fields[k]) fields[k].textContent = "00"; });
        clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      if (fields.days) fields.days.textContent = pad(Math.floor(s / 86400));
      if (fields.hours) fields.hours.textContent = pad(Math.floor((s % 86400) / 3600));
      if (fields.minutes) fields.minutes.textContent = pad(Math.floor((s % 3600) / 60));
      if (fields.seconds) fields.seconds.textContent = pad(s % 60);
    };
    tick();
    var timer = setInterval(tick, 1000);
  }

  /* =========================================================================
     Seat map ⇄ category selector.

     Three views of the same state, all keyed on `data-zone`:
       · the radio inputs in the buy box
       · the legend buttons under the map
       · the <g class="seatmap-zone"> groups inside the SVG

     Anything can originate a change; `select()` is the only thing that writes,
     and every view re-reads from the radios. That keeps them from drifting.
  ========================================================================= */

  var seatmap = $("[data-seatmap]");
  var radios = $$('.category input[type="radio"]');
  var priceEl = $("[data-price-display]");

  if (radios.length) {
    var legendBtns = $$("[data-seat-category]");
    var zoneGroups = seatmap ? $$(".seatmap-zone", seatmap) : [];
    var status = seatmap ? $("[data-seatmap-status]", seatmap) : null;

    /** zone key -> the radio that owns it (first match wins). */
    var radioForZone = {};
    radios.forEach(function (r) {
      var z = r.getAttribute("data-zone");
      if (z && !radioForZone[z]) radioForZone[z] = r;
    });

    var nameForZone = function (zone) {
      var btn = legendBtns.filter(function (b) { return b.getAttribute("data-zone") === zone; })[0];
      if (btn) {
        var n = $(".seatmap__legend-name", btn);
        if (n) return n.textContent.trim();
      }
      var r = radioForZone[zone];
      if (r) {
        var label = r.closest(".category__option");
        var nm = label && $(".category__name", label);
        if (nm) return nm.textContent.trim();
      }
      return zone;
    };

    /* ---- Make SVG zones real controls -------------------------------------
       Done here rather than in the SVG files so the arena snippets stay pure
       geometry and the accessible name comes from the actual category. */
    zoneGroups.forEach(function (g) {
      var zone = g.getAttribute("data-zone");
      var radio = radioForZone[zone];

      if (!radio || radio.disabled) {
        g.classList.add("is-unavailable");
        g.setAttribute("aria-hidden", "true");
        g.style.pointerEvents = "none";
        return;
      }

      g.setAttribute("role", "button");
      g.setAttribute("tabindex", "0");
      g.setAttribute("aria-label", "Select " + nameForZone(zone));

      // Fill the labels the SVG leaves blank: the band name across each ring,
      // and the price on the floor block. Kept out of the SVG files so those
      // stay pure geometry and the text always matches the live catalogue.
      $$("[data-zone-name]", g).forEach(function (el) {
        el.textContent = nameForZone(zone);
      });
      $$("[data-zone-price]", g).forEach(function (el) {
        el.textContent = radio.getAttribute("data-price") || "";
      });
    });

    /* ---- Render: every view reflects the checked radio ---- */
    var render = function () {
      var checked = radios.filter(function (r) { return r.checked; })[0];
      var zone = checked ? checked.getAttribute("data-zone") : null;

      if (priceEl && checked && checked.getAttribute("data-price")) {
        priceEl.textContent = checked.getAttribute("data-price");
      }

      legendBtns.forEach(function (b) {
        var on = checked && b.getAttribute("data-seat-category") === checked.value;
        b.classList.toggle("is-active", !!on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });

      zoneGroups.forEach(function (g) {
        var on = zone && g.getAttribute("data-zone") === zone;
        g.classList.toggle("is-selected", !!on);
        if (g.getAttribute("role") === "button") {
          g.setAttribute("aria-pressed", on ? "true" : "false");
        }
      });

      if (seatmap) seatmap.classList.toggle("has-selection", !!zone);
    };

    /** The single writer. */
    var select = function (radio, announce) {
      if (!radio || radio.disabled || radio.checked) {
        if (radio && radio.checked) render();
        return;
      }
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
      if (announce && status) {
        status.textContent = nameForZone(radio.getAttribute("data-zone")) + " selected.";
      }
    };

    radios.forEach(function (r) { r.addEventListener("change", render); });

    /* ---- Legend buttons ---- */
    legendBtns.forEach(function (btn) {
      var id = btn.getAttribute("data-seat-category");
      var radio = radios.filter(function (r) { return r.value === id; })[0];
      var zone = btn.getAttribute("data-zone");

      btn.addEventListener("click", function () {
        select(radio, true);
        // On narrow screens the buy box sits below the map; bring it into view.
        if (radio && window.matchMedia("(max-width: 999px)").matches) {
          var fs = radio.closest(".category");
          if (fs) fs.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });

      // Hovering the legend previews the zone on the map, and vice versa.
      var setHover = function (on) {
        zoneGroups.forEach(function (g) {
          if (g.getAttribute("data-zone") === zone) g.classList.toggle("is-hovered", on);
        });
      };
      btn.addEventListener("mouseenter", function () { setHover(true); });
      btn.addEventListener("mouseleave", function () { setHover(false); });
      btn.addEventListener("focus", function () { setHover(true); });
      btn.addEventListener("blur", function () { setHover(false); });
    });

    /* ---- SVG zones ---- */
    zoneGroups.forEach(function (g) {
      var zone = g.getAttribute("data-zone");
      var radio = radioForZone[zone];
      if (!radio || radio.disabled) return;

      g.addEventListener("click", function () { select(radio, true); });

      g.addEventListener("keydown", function (e) {
        if (e.key !== "Enter" && e.key !== " " && e.key !== "Spacebar") return;
        e.preventDefault();
        select(radio, true);
      });

      var setHover = function (on) {
        legendBtns.forEach(function (b) {
          if (b.getAttribute("data-zone") === zone) b.classList.toggle("is-hovered", on);
        });
      };
      g.addEventListener("mouseenter", function () { setHover(true); });
      g.addEventListener("mouseleave", function () { setHover(false); });
      g.addEventListener("focus", function () { setHover(true); });
      g.addEventListener("blur", function () { setHover(false); });
    });

    render();
  }

  /* -------------------------------------------------------------------------
     Add-ons: each is its own `items[n]` cart line. Unchecked ones are disabled
     so the browser omits them, rather than rebuilding the payload in JS.
  ------------------------------------------------------------------------- */
  $$("[data-addon-toggle]").forEach(function (box) {
    var id = box.getAttribute("data-addon-target");
    var idInput = document.getElementById(id);
    var qtyInput = $('[data-addon-qty-for="' + id + '"]');
    var sync = function () {
      if (idInput) idInput.disabled = !box.checked;
      if (qtyInput) qtyInput.disabled = !box.checked;
    };
    box.addEventListener("change", sync);
    sync();
  });

  /* -------------------------------------------------------------------------
     Never submit without a category.
  ------------------------------------------------------------------------- */
  var form = $("[data-pdp-form]");
  if (form) {
    form.addEventListener("submit", function (e) {
      var any = radios.some(function (r) { return r.checked && !r.disabled; });
      if (!any) {
        e.preventDefault();
        var first = radios.filter(function (r) { return !r.disabled; })[0];
        if (first) {
          first.checked = true;
          first.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    });
  }
})();
